const TOGGLE_FULLSCREEN_MODE = 'TOGGLE_FULLSCREEN_MODE';

const toggleFullScreenMode = () => ({
    type: TOGGLE_FULLSCREEN_MODE,
});

const initialState = {
    isFullScreen: false,
};

const fullScreenModeReducer = (state = initialState, action) => {
    switch (action.type) {
    case TOGGLE_FULLSCREEN_MODE: {
        return {
            ...state,
            isFullScreen: !state.isFullScreen,
        };
    }
    default:
        return state;
    }
};


export { fullScreenModeReducer, toggleFullScreenMode };
